import { Sheet } from '../ui/controls';
import { Icon } from '../ui/icons';
import { useApp } from '../data/store';
import { KHUTBAH_ADDON, PLANS, PLAN_LIMIT_TEXT, personLimitText } from '@noorview/core';

export function UpgradeSheet({ onClose, reason }: { onClose: () => void; reason?: 'screens' | 'users' }) {
  const plan = useApp((s) => s.ws?.masjid.plan ?? 'free');
  return (
    <Sheet open onClose={onClose} title={reason ? 'Upgrade to add more' : 'Plans'} subtitle={reason === 'users' ? personLimitText(plan) : reason ? PLAN_LIMIT_TEXT[reason] : 'Choose the plan that fits your masjid.'} size="wide"
      footer={<><button type="button" className="btn plain" onClick={onClose}>Not now</button><a className="btn primary" href="https://www.noormsystems.co.uk/#contact" target="_blank" rel="noopener">Talk to us about upgrading</a></>}>
      <div className="plans-row">
        {PLANS.map((p) => (
          <div key={p.id} className={`plan-c ctl${p.id === plan ? ' cur' : ''}${p.id === 'own' ? ' own' : ''}`}>
            <b>{p.name}</b><div className="price"><span>{p.price}</span><small>{p.note}</small></div>
            <ul>{p.feats.map((f) => <li key={f}><Icon name="check" size={16} />{f}</li>)}</ul>
            {p.id === plan && <span className="pill online">Your plan</span>}
          </div>
        ))}
      </div>
      <div className="section-label">Add-on</div>
      <div className="plan-c ctl">
        <b>{KHUTBAH_ADDON.name}</b><div className="price"><span>{KHUTBAH_ADDON.price}</span><small>{KHUTBAH_ADDON.note}</small></div>
        <ul>{KHUTBAH_ADDON.feats.map((f) => <li key={f}><Icon name="check" size={16} />{f}</li>)}</ul>
        {useApp.getState().ws?.masjid.khutbahAddon && <span className="pill online">Added</span>}
      </div>
    </Sheet>
  );
}
